<template>
  <div>
    <a-card
      size="small"
      title="查询"
      :headStyle="{
        background: '#f3f3f3',
      }"
    >
      <a-form layout="inline">

        <a-form-item>
          <df-selectShop
              @setValue="searchAction()"
              :model="searchForm"
          ></df-selectShop>
        </a-form-item>


        <a-form-item>
          <a-input
            v-model:value="searchForm.code"
            allowClear
            @keyup.enter.native="searchAction()"
            :placeholder="'请输入' + codeType"
          >
            <template v-slot:addonBefore>
              <a-select v-model:value="codeType" style="width: 100px">
                <a-select-option value="订单编号"> 订单编号 </a-select-option>
                <a-select-option value="顾客姓名"> 顾客姓名 </a-select-option>
                <a-select-option value="供应编号"> 供应编号 </a-select-option>
                <a-select-option value="电话号码"> 电话号码 </a-select-option>
              </a-select>
            </template>
          </a-input>
        </a-form-item>

        <a-form-item>
          <df-selectStationList
            :region="searchForm.from"
            @setValue="setValue"
          ></df-selectStationList>
        </a-form-item>
        <a-form-item> -- </a-form-item>
        <a-form-item>
          <df-selectStationList
            :title="'终到站'"
            :region="searchForm.to"
            @setValue="setValue"
          ></df-selectStationList>
        </a-form-item>

        <a-form-item>
          <a-range-picker
            v-model:value="searchForm.date"
            :placeholder="['出票开始', '出票结束']"
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
          />
        </a-form-item>

        <a-form-item>
          <a-range-picker
            v-model:value="searchForm.orderdate"
            :placeholder="['下单开始', '下单结束']"
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
          />
        </a-form-item>

        <a-form-item>
          <a-button type="primary" @click="searchAction"> 查询 </a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="supplierOrdersDownload">下载</a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
        <a-form-item> </a-form-item>
      </a-form>
    </a-card>
    <a-card
      size="small"
      title=""
      :defaultActiveTabKey="activeKey"
      style="margin-top: 20px"
      @tabChange="cardtabChange"
      class="log_content"
      :headStyle="{
        background: '#f3f3f3',
      }"
      :bodyStyle="{
        padding: '0',
      }"
      :tabList="panes"
    >
      <a-table
        :columns="columns"
        bordered
        :data-source="list"
        :pagination="false"
        :scroll="{ x: 1300 }"
        :row-key="(r) => r.id"
        :loading="loading"
      >
        <template v-slot:orderCode="{ text, record }">
          <div
            style="color: #464c5b; cursor: pointer"
            @click="toDetail(record)"
          >
            {{ record.orderCode }}
          </div>
        </template>
        <template v-slot:train="{ text, record }">
          <div>
            {{ record.fromStation }} -> {{ record.toStation
            }}<span style="color: red; margin-left: 10px"
              >({{ record.trainNo }})</span
            >
          </div>
          <div>
            {{ record.fromTimeFormat }}&nbsp;&nbsp; - &nbsp;&nbsp;{{
              record.toTimeFormat
            }}
          </div>

          <div v-if="record.purchaseType === 1">
            <a-button type="primary" size="small" @click="backfill(record)">
              回填票号
            </a-button>
          </div>
        </template>

        <template v-slot:passengersList="{ text, record }">
          <a-table
            :columns="columnsInner"
            bordered
            :data-source="record.purchaseTickets"
            :pagination="false"
            :showHeader="false"
            :row-key="(r) => r.id"
          >
            <template v-slot:site="{ text, record }">
              {{ record.lastCoach }}/{{ record.lastSeat }}
            </template>
          </a-table>
        </template>

        <template v-slot:money="{ text, record }">
          <span style="color: red">¥{{ record.totalAmount }}</span>
        </template>

        <template v-slot:orderState="{ text, record }">
          {{ record.stateValue }}
        </template>

        <template v-slot:operation="{ text, record }">
          <a-button type="primary" @click="toDetail(record)">
            查看订单
          </a-button>
          <!-- style='margin-left:5px' -->
          <!-- <a-button type="danger"  @click="cancel(record)" v-if='record.orderState == 30 || record.orderState == 60'>
            取消订单
          </a-button> -->
        </template>
      </a-table>
    </a-card>

    <df-pagination :model="pageObj"></df-pagination>
    <a-modal
      v-model:visible="modalVisible"
      :title="'回填单号(' + modelDetail.orderCode + ')'"
      :width="1200"
      @ok="handleOk"
    >
      <!-- @ok="handleOk" -->
      <df-titleline
        :title="'基本信息'"
        style="margin: 0; margin-bottom: 10px"
      ></df-titleline>
      <a-row class="title_row">
        <a-col>
          <span class="clb">订单号：</span>
          {{ modelDetail.orderCode }}
        </a-col>
      </a-row>
      <a-row class="title_row">
        <a-col>
          <span class="clb">出发/到达：</span>

          <a-tag color="pink">
            {{ modelDetail.fromStation }}
          </a-tag>
          <span> ->({{ modelDetail.takeTimeFormat }})-> </span>
          <a-tag color="pink">
            {{ modelDetail.toStation }}
          </a-tag>
        </a-col>
      </a-row>
      <a-row class="title_row">
        <a-col>
          <span class="clb">订单渠道：</span>
          暂无接口数据
        </a-col>
      </a-row>
      <a-row class="title_row">
        <a-col>
          <span class="clb">订单供应：</span>
          暂无接口数据
        </a-col>
      </a-row>
      <df-titleline
        :title="'乘客信息'"
        style="margin-bottom: 10px"
      ></df-titleline>
      <a-table
        :columns="columnsbackfill"
        bordered
        :data-source="modelDetail.purchaseTickets"
        :pagination="false"
        :scroll="{ x: 900 }"
        :row-key="(r) => r.id"
      >
        <template v-slot:ticketNo="{ text, record, index }">
          <a-input
            placeholder="票号"
            v-model:value="fillForm[index].ticketNo"
            allowClear
          />
        </template>

        <template v-slot:seat="{ text, record, index }">
          <a-input
            placeholder="车厢"
            v-model:value="fillForm[index].lastCoach"
            style="width: 40%"
          />
          /
          <a-input
            placeholder="座位"
            v-model:value="fillForm[index].lastSeat"
            style="width: 40%"
          />
        </template>

        <template v-slot:price="{ text, record, index }">
          <a-input
            placeholder="采购价"
            v-model:value="fillForm[index].price"
            allowClear
          />
        </template>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import orderApi from "@axios/order";
import moment from "moment";
import { reactive, ref, provide } from "vue";
import orderState from "@assets/static";
import { useRouter } from "vue-router";
import { SmileOutlined } from "@ant-design/icons-vue";
import { Modal, destroyAll, notification, message } from "ant-design-vue";
import excelApi from "@axios/downloadExcel";
import tools from "@/utils/tools";

export default {
  name: "shop",
  components: {
    SmileOutlined,
  },
  setup() {
    const router = useRouter();
    const columnsInner = [
      {
        title: "票号",
        dataIndex: "ticketNo",
        width: 100,
        align: "center",
      },
      {
        title: "购票人",
        dataIndex: "passengerName",
        width: 100,
        align: "center",
      },
      {
        title: "座位",
        dataIndex: "orderCode",
        width: 100,
        align: "center",
        slots: { customRender: "site" },
      },
    ];
    let panes = ref([
      { tab: "全部", key: "0" },
      { tab: "占座中", key: "20" },
      { tab: "占座成功", key: "30" },
      { tab: "出票中", key: "40" },
      { tab: "占座失败", key: "60" },
      { tab: "取消订单", key: "90" },
    ]);
    let modalVisible = ref(false);
    let visible = ref(false);
    let loading = ref(false);
    let submitForm = reactive({});
    let searchForm = reactive({
      code: "",
      passenger: "",
      date: [],
      orderdate: [],
      from: "",
      to: "",
      supplierId: undefined
    });
    let searchParams = reactive({
      code: "",
      passenger: "",
      date: [],
      orderdate: [],
      from: "",
      to: "",
      supplierOrderCode:undefined
    });
    let list = ref([]);

    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });

    let activeKey = ref("0");

    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    const cardtabChange = (key) => {
      activeKey.value = key;
      reset();
    };

    let fillForm = ref([
      // {
      //   id : '',
      //   lastCoach : '',
      //   lastSeat : '',
      //   price : '',
      //   ticketNo : '',
      // }
    ]);

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);


    const supplierOrdersDownload = () => {

      searchParams.supplierId = searchForm.supplierId;
      searchParams.code = searchForm.code;
      searchParams.date = searchForm.date;
      searchParams.orderdate = searchForm.orderdate;
      searchParams.from = searchForm.from;
      searchParams.to = searchForm.to;

      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      let params = {
        supplierId: searchParams.supplierId,
        fromStation: searchParams.from ? searchParams.from : null,
        toStation: searchParams.to ? searchParams.to : null,
        state: activeKey.value == "0" ? null : activeKey.value,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
      };

      if (searchParams.orderdate.length) {
        params.orderBeginTime = searchParams.orderdate[0];
        params.orderEndTime = searchParams.orderdate[1];
      }

      if (searchParams.date.length) {
        params.finishBeginTime = searchParams.date[0];
        params.finishEndTime = searchParams.date[1];
      }
      if (searchParams.code) {
        if (codeType.value == "订单编号") {
          params.orderCode = searchParams.code;
        } else if (codeType.value == "顾客姓名") {
          params.passengerName = searchParams.code;
        } else if (codeType.value == "供应编号") {
          params.supplierOrderCode = searchParams.code;
        }else {
          params.mobile = searchParams.code;
        }
      }
      if (params.orderBeginTime === undefined || params.orderBeginTime === '' || params.orderEndTime === undefined || params.orderEndTime === ''){
        message.error("请选择下单时间区间！");
        return
      }
      if (!tools.isWithinLastThreeMonths(params.orderBeginTime,params.orderEndTime)){
        message.error("下单时间区间，不能大于三个月！");
        return
      }

      excelApi.purchaseOrdersExcel(params).then((res) => {
        let blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"}); // 为blob设置文件类型，这里以.xlsx为例
        let url = window.URL.createObjectURL(blob); // 创建一个临时的url指向blob对象
        let a = document.createElement("a");
        a.href = url;
        a.download = '供应订单报表'+tools.getNowDate();
        a.click();
        // 释放这个临时的对象url
        window.URL.revokeObjectURL(url);
        //getList();
      }).catch((err) => {});


    }


    const searchAction = () => {
      searchParams.supplierId = searchForm.supplierId;
      searchParams.code = searchForm.code;
      searchParams.date = searchForm.date;
      searchParams.orderdate = searchForm.orderdate;
      searchParams.from = searchForm.from;
      searchParams.to = searchForm.to;

      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      getList();
    };

    const getList = () => {
      loading.value = true;
      let params = {
        supplierId: searchParams.supplierId,
        fromStation: searchParams.from ? searchParams.from : null,
        toStation: searchParams.to ? searchParams.to : null,
        state: activeKey.value == "0" ? null : activeKey.value,
        currentPage: pageObj.value.page,
        size: pageObj.value.rows,
      };

      if (searchParams.orderdate.length) {
        params.orderBeginTime = searchParams.orderdate[0];
        params.orderEndTime = searchParams.orderdate[1];
      }

      if (searchParams.date.length) {
        params.finishBeginTime = searchParams.date[0];
        params.finishEndTime = searchParams.date[1];
      }
      if (searchParams.code) {
        if (codeType.value == "订单编号") {
          params.orderCode = searchParams.code;
        } else if (codeType.value == "顾客姓名") {
          params.passengerName = searchParams.code;
        } else if (codeType.value == "供应编号") {
          params.supplierOrderCode = searchParams.code;
        }else {
          params.mobile = searchParams.code;
        }
      }

      orderApi.getPurchaseList(params).then((res) => {
        console.log(res);
        loading.value = false;
        if (!res) return;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;
        list.value = res.data;
      });
      getCount(params);
    };

    const getCount = (params) => {
      orderApi.purchaseCount(params).then((res) => {
        panes.value = [
          { tab: "全部", key: "0" },
          { tab: "占座中", key: "20" },
          { tab: "占座成功", key: "30" },
          { tab: "出票中", key: "40" },
          { tab: "占座失败", key: "60" },
          { tab: "取消订单", key: "90" },
        ];

        let sum = 0;
        for (var key in res) {
          sum += res[key];
        }

        panes.value.forEach((element) => {
          console.log();
          if (element.key != "0" && res["count" + element.key]) {
            element.tab =
              element.tab + " ( " + res["count" + element.key] + " ) ";
          } else if (element.key == "0" && sum) {
            element.tab = element.tab + " ( " + sum + " ) ";
          }
        });
      });
    };

    const reset = () => {
      searchForm.code = "";
      searchForm.date = [];
      searchForm.orderdate = [];
      searchForm.from = "";
      searchForm.to = "";

      searchAction();
    };

    const toDetail = (row) => {
      router.push({
        name: "supplyDetailIndex",
        query: {
          code: row.orderCode,
        },
      });
    };

    const cancel = (row) => {
      Modal.confirm({
        content: "是否确定取消该订单？",
        onOk() {
          let params = {
            orderCode: row.orderCode,
          };
          orderApi.orderConcel(params).then((res) => {
            notification.open({
              message: "取消成功",
              icon: <SmileOutlined style="color: #108ee9" />,
            });
            getList();
          });
        },
        cancelText: "取消",
        okText: "确定",
        onCancel() {
          Modal.destroyAll();
        },
      });
    };

    const setValue = (v) => {
      if (v.title == "始发站") {
        searchForm.from = v.val;
      } else {
        searchForm.to = v.val;
      }
    };

    let codeType = ref("订单编号");
    let modelDetail = ref({});
    const backfill = (row) => {
      modalVisible.value = true;
      modelDetail.value = row;
      fillForm.value = [];
      console.log(row);
      row.purchaseTickets.forEach((element) => {
        let obj = {
          id: element.id,
          lastCoach: element.lastCoach,
          lastSeat: element.lastSeat,
          price: element.price,
          ticketNo: element.ticketNo,
        };
        fillForm.value.push(obj);
      });
      console.log(fillForm.value);
    };

    const handleOk = () => {
      console.log(fillForm.value);
      //验证回填参数
      let tag = fillForm.value.every((value) => {
        return (
          value.lastCoach && value.lastSeat && value.price && value.ticketNo
        );
      });

      if (!tag) {
        message.error("请仔细填写回填数据不能为空");
        return;
      }

      let params = {
        supplierId: 1,
        purchaseTicketVos: fillForm.value,
      };

      orderApi.fill(params).then((res) => {
        notification.open({
          message: "回填成功",
          icon: <SmileOutlined style="color: #108ee9" />,
        });
        modalVisible.value = false;
        getList();
      });
    };

    getList();
    return {
      handleOk,
      fillForm,
      modelDetail,
      backfill,
      setValue,
      codeType,
      cancel,
      panes,
      reset,
      searchAction,
      supplierOrdersDownload,
      activeKey: activeKey,
      modalVisible,
      visible,
      loading,
      submitForm,
      list,
      rules: {
        state: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
      stateList: [
        {
          name: "供应",
          val: 10,
        },
        {
          name: "渠道",
          val: 20,
        },
      ],
      columnsbackfill: [
        {
          title: "姓名",
          dataIndex: "passengerName",
          width: 40,
          align: "center",
        },
        {
          title: "证件号",
          dataIndex: "cardNo",
          width: 60,
          align: "center",
        },
        {
          title: "手机号码",
          dataIndex: "mobile",
          width: 50,
          align: "center",
        },
        {
          title: "车票类型",
          dataIndex: "passengerTypeValue",
          width: 50,
          align: "center",
        },
        {
          title: "票号",
          dataIndex: "ticketNo",
          width: 100,
          align: "center",
          slots: { customRender: "ticketNo" },
        },
        {
          title: "座位信息",
          dataIndex: "passengerTypeValue",
          width: 100,
          align: "center",
          slots: { customRender: "seat" },
        },
        {
          title: "采购价",
          dataIndex: "passengerTypeValue",
          width: 50,
          align: "center",
          slots: { customRender: "price" },
        },
      ],
      columns: [
        {
          title: "订单编号",
          dataIndex: "orderCode",
          width: 200,
          align: "center",
          slots: { customRender: "orderCode" },
        },
        {
          title: "供应编号",
          dataIndex: "supplierOrderCode",
          width: 200,
          align: "center",
          slots: { customRender: "supplierOrderCode" },
        },
        {
          title: "车次信息",
          dataIndex: "mobile",
          width: 300,
          align: "left",
          slots: { customRender: "train" },
        },
        {
          title: "票号/购票人/座位",
          dataIndex: "taxpayerNum",
          width: 400,
          align: "center",
          slots: { customRender: "passengersList" },
        },
        {
          title: "订单金额",
          dataIndex: "stateName",
          width: 100,
          align: "center",
          slots: { customRender: "money" },
        },
        {
          title: "提交时间",
          dataIndex: "createTime",
          width: 150,
          align: "center",
        },
        {
          title: "订单状态",
          dataIndex: "22",
          width: 150,
          align: "center",
          slots: { customRender: "orderState" },
        },
        {
          title: "操作",
          align: "center",
          dataIndex: "operation",
          key: "operation",
          width: 220,

          slots: { customRender: "operation" },
        },
      ],
      searchForm,
      searchParams,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      moment,
      pageObj,
      disabledDate(current) {
        // Can not select days before today and today

        return current && current < moment().endOf("day");
      },
      cardtabChange,
      columnsInner,
      orderState,
      toDetail,
    };
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.log_content /deep/ .ant-card-extra {
  float: none;
  margin-left: 0;
}
.title_row {
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
